export const PR_TEAM_IDS = [
  1, // Abror
  5, // Catherine
  11, // Annabelle
  28, // Abigail
  29, // Rukayat
];
